import { KEYS_FIELD_LIST, SELECT_FIELD } from '../constants'

export const getRemainingFieldSelection = (
  rowId,
  listFieldRequest,
  allFields,
) => {
  let selectedFieldsValueByRow = []
  const allSelectedValues = listFieldRequest.map((item) => item.value)

  for (let i = 0; i < rowId; i++) {
    selectedFieldsValueByRow.push(allSelectedValues[i])
  }

  return [
    ...[SELECT_FIELD, ...allFields].filter(
      (field) => !selectedFieldsValueByRow.includes(field.value),
    ),
  ]
}

export const convertToCamelCase = (str) => {
  if (!str.length) {
    return ''
  }

  return str?.charAt(0).toLowerCase() + str?.slice(1)
}

export const getAutoFilledVal = (userProfile, fieldName) => {
  if (
    fieldName?.toLowerCase() === KEYS_FIELD_LIST?.CONTACT_EMAIL.toLowerCase()
  ) {
    return userProfile[KEYS_FIELD_LIST.EMAIL] || ''
  }

  return userProfile[convertToCamelCase(fieldName)]
    ? userProfile[convertToCamelCase(fieldName)]?.toString()
    : ''
}
